import { ref } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';

const UPLOAD_URL = "https://upload.imagekit.io/api/v2/files/upload";
const PUBLIC_KEY = "public_ZP21Qb8KYldUuun4HvyHhiURLSU=";
const AUTH_HEADER = "Basic cHJpdmF0ZV96b08rVGJUeTRoY3JjY0loYUZLZm80Zk1FWFE9Og==";
const URL_ENDPOINT = "https://ik.imagekit.io/therealdevspro";

export function useImageKit() {
  const uploading = ref(false);
  const error = ref(null);

  /**
   * Función privada para comprimir la imagen usando Canvas
   */
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const maxWidth = 700; // Máximo ancho para evidencias
      const quality = 0.7;  // Calidad 70%
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = (maxWidth / width) * height;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              // Retornamos un nuevo archivo JPEG comprimido
              const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".jpg", {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              reject(new Error('Error al comprimir imagen'));
            }
          }, 'image/jpeg', quality);
        };
      };
      reader.onerror = (err) => reject(err);
    });
  };

  /**
   * Sube archivo comprimido directamente a ImageKit
   */
  const uploadFile = async (file, folder = "/") => {
    if (!file) return null;

    uploading.value = true;
    error.value = null;

    try {
      // 1. COMPRESIÓN: Procesar antes de subir
      const fileToUpload = await compressImage(file);

      // 2. Generar nombre UUID
      const uniqueFileName = `${self.crypto.randomUUID()}.jpg`;

      // 3. Preparar FormData
      const formData = new FormData();
      formData.append("file", fileToUpload);
      formData.append("fileName", uniqueFileName);
      formData.append("useUniqueFileName", "false");
      formData.append("publicKey", PUBLIC_KEY);
      formData.append("folder", folder);

      // 4. Petición Directa
      const res = await axios.post(UPLOAD_URL, formData, {
        headers: {
          "Authorization": AUTH_HEADER,
          "Content-Type": "multipart/form-data"
        }
      });

      const filePath = res.data.filePath;
      // Quitamos la transformación tr=w-400 del final si ya la subimos pequeña,
      // o la dejamos para asegurar el display uniforme.
      const finalUrl = `${URL_ENDPOINT}${filePath}`;

      Swal.fire({
        icon: 'success',
        title: 'Imagen optimizada y subida',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      return finalUrl;

    } catch (err) {
      console.error("ImageKit Error:", err);
      error.value = err.response?.data?.message || "Error al subir";

      Swal.fire({
        icon: 'error',
        title: 'Error de subida',
        text: 'La imagen es demasiado pesada o hubo un error de red.',
        confirmButtonColor: '#ec4899'
      });

      return null;
    } finally {
      uploading.value = false;
    }
  };

  return {
    uploading,
    error,
    uploadFile
  };
}